import { useMutation } from '@tanstack/react-query'
import { SuggestionsApi } from 'src/services/suggestionsApi'
import {
  RelevancyParams,
  RelevancyResult,
} from 'src/services/__generated__/api'

const updateRelevancy = async (
  params: RelevancyParams
): Promise<RelevancyResult | null> => {
  try {
    const { data } = await SuggestionsApi.v1.relevancyCreate(params)

    return data
  } catch {
    return null
  }
}

export const useUpdateRelevancy = () => {
  return useMutation({
    mutationFn: (params: RelevancyParams) => {
      return updateRelevancy(params)
    },
    // The relevancy call is a background enrichment — a failed request should
    // not surface a runtime error overlay. Swallow silently.
    onError: () => {},
  })
}
